type RouteSlug = string | string[] | undefined

export function usePageSlug(slug: RouteSlug) {
  if (!slug)
    return { pageSlug: "" }

  const normalized = Array.isArray(slug) ? slug.filter(Boolean) : slug

  return { pageSlug: Array.isArray(normalized) ? normalized.join("/") : normalized }
}
